
    import './styles.scoped.css';
    export default {
  "heading-text": "awsui_heading-text_105ke_268sp_5"
};
  